import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from 'src/app/shared/shared.module';
import {LineOfBusinessComponent} from 'src/app/main/line-of-business/line-of-business.component';
import {LineOfBusinessRoutingModule} from './line-of-business-routing.module';
import {ToolbarModule} from 'src/app/layout/toolbar/toolbar.module';
import {IconsModule} from '../../icons/icons.module';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatCardModule} from '@angular/material/card';
import {TableModule} from 'src/app/table/table.module';
import {PaginatorModule} from 'src/app/components/paginator/paginator.module';
import {MatMenuModule} from '@angular/material/menu';
import {AddLineOfBusinessComponent} from './add-line-of-business/add-line-of-business.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ErrorModule} from 'src/app/components/error/error.module';
import {SidenavHeaderModule} from 'src/app/components/sidenav-header/sidenav-header.module';

@NgModule({
  declarations: [
    LineOfBusinessComponent,
    AddLineOfBusinessComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    LineOfBusinessRoutingModule,
    ToolbarModule,
    IconsModule,
    MatProgressSpinnerModule,
    MatCardModule,
    TableModule,
    PaginatorModule,
    MatMenuModule,
    FormsModule,
    ReactiveFormsModule,
    ErrorModule,
    SidenavHeaderModule
  ]
})
export class LineOfBusinessModule {
}
